export default __webpack_public_path__ + "00a0178edec4adc65eb6025ad0f1e43e.png";